angular
  .module('cfn')
  .factory('cropSequencePlanningService', cropSequencePlanningService);

cropSequencePlanningService.$inject = [
  '$log',
  '$http',
  '$q',
  '$timeout',
  'presentationModelFactory',
];
function cropSequencePlanningService(
  $log,
  $http,
  $q,
  $timeout,
  presentationModelFactory,
) {
  
  let URL = {
    cropsequences: '/365FarmNet/mod/crop-planning-service/rest/planning/cropsequence/v1.0/',
  };
  
  var saveTimeout;
  return {
    getSysCultures: function (callback) {
      const url = '/365FarmNet/rest/core/sysculture';

      return $http.get(url).then(
        function (response) {
          callback(response.data);
        },
        function () {
          console.log('Error loading sysCultures');
        }
      );
    },
    getFarms: function (callback) {
      return $http.get('/365FarmNet/rest/core/farm').then(
        function (response) {
          callback(response.data);
        },
        function () {
          console.log('Error loading farms');
        }
      );
    },
    getFieldGroups: function (callback) {
      return $http.get('/365FarmNet/rest/core/fieldgroup').then(
        function (response) {
          callback(response.data);
        },
        function () {
          console.log('Error loading field groups');
        }
      );
    },
    getPlan: function (options, callback) {
      app.showLoader();
      var call =
        URL.cropsequences +
        options.selectedYear;
      return $http.get(call).then(
        function (response) {
          var data = response.data;
          // Notify user if backend has added, removed or updated any field
          var rows = data.rows;
          var isFieldListChanged = rows.some(function (elem) {
            return elem.changes !== null;
          });

          // Backend returns inactive and deleted rows and just marks them. Removed them as we don't
          // need them
          rows = rows.filter(function (elem) {
            return elem.changes !== 'INACTIVE' && elem.changes !== 'DELETED';
          });

          callback(
            presentationModelFactory.makeDataList(rows),
            data.farms,
            isFieldListChanged
          );
          app.hideLoader();
        },
        function () {
          console.log('Error loading cropsequenceplanning per year');
        }
      );
    },
    save: function (year, newVal) {
      var storeFieldPlan = newVal;

      if (saveTimeout) {
        $timeout.cancel(saveTimeout);
      }

      saveTimeout = $timeout(function () {
        $http
          .post(
            URL.cropsequences + year,
            presentationModelFactory.getPlainData(storeFieldPlan)
          )
          .catch(function () {
            console.log('POST ERROR');
          });
      }, 1000);
    },
    getCulturesOfYear: function (year) {
      return $http.get(
        URL.cropsequences + year + '/cultures'
      );
    },
    // Load list of relevant harvest years
    getAllowedYears: function getAllowedYears() {
      var url = '/365FarmNet/rest/analyse/cropoverview/harvestyears'
      return $http({
        method: 'GET',
        url: url,
      });
    },
  };
}

export default cropSequencePlanningService;
